import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { CssButton, CssIcon, CssInput } from "styles/helpers/layout";

export const StyledStudentIcon = styled(CssIcon)<Props>`
  color: ${(props: Props) => props.theme.palette.secondary.brand};
`;

export const StyledShareableLink = styled(CssInput)<Props>`
  border: 0;
  padding: 0.5rem 1.25rem;
  background: ${(props: Props) => props.theme.palette.neutral._950};
  border-radius: ${(props: Props) => props.theme.borderRadius.rounded};
`;

export const StyledButton = styled(CssButton)<Props>`
  font-weight: normal;
  padding: 0.5rem 1.25rem;

  .content {
    display: flex;
    align-items: center;
    column-gap: 0.75rem;
  }
`;
